import { baseService } from '../base';
import {
  TBusinessAddress,
  TCreateBusinessAddress,
  TUpdateBusinessAddress,
} from '~/types/business-address';

export const getBusinessAddresses = async (
  activeOnly = false,
): Promise<TBusinessAddress[]> => {
  const params = activeOnly ? { activeOnly: 'true' } : {};
  const { data } = await baseService.get<TBusinessAddress[]>('/business-addresses', { params });
  return data;
};

export const getBusinessAddress = async (
  id: string,
): Promise<TBusinessAddress> => {
  const { data } = await baseService.get<TBusinessAddress>(`/business-addresses/${id}`);
  return data;
};

export const createBusinessAddress = async (
  payload: TCreateBusinessAddress,
): Promise<TBusinessAddress> => {
  const { data } = await baseService.post<TBusinessAddress>('/business-addresses', payload);
  return data;
};

export const updateBusinessAddress = async (
  id: string,
  payload: TUpdateBusinessAddress,
): Promise<TBusinessAddress> => {
  const { data } = await baseService.patch<TBusinessAddress>(
    `/business-addresses/${id}`,
    payload,
  );
  return data;
};

export const toggleBusinessAddressActive = async (
  id: string,
): Promise<TBusinessAddress> => {
  const { data } = await baseService.patch<TBusinessAddress>(
    `/business-addresses/${id}/toggle-active`,
  );
  return data;
};

export const deleteBusinessAddress = async (id: string): Promise<void> => {
  await baseService.delete(`/business-addresses/${id}`);
};
